<template>
  <svg fill="none" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M16 8.016A8.52 8.52 0 0 0 8.016 16h-.032A8.52 8.52 0 0 0 0 8.016v-.032A8.52 8.52 0 0 0 7.984 0h.032A8.52 8.52 0 0 0 16 7.984z" />
    <defs>
      <radialGradient
        id="a"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(18.683 -18.972 8.078)scale(17.03 136.421)"
        gradientUnits="userSpaceOnUse">
        <stop offset=".067" stop-color="currentColor" />
        <stop offset=".343" stop-color="currentColor" />
        <stop offset=".672" stop-color="currentColor" />
      </radialGradient>
    </defs>
  </svg>
</template>
